import { useState } from 'react'
import { daysInMonth } from './getDaysInMonth'
import { datesAreOnSameDay } from './datesAreTheSame'
import { CalendarDayObject, WeekObject } from '../PostCalendar'
import { CalendarDateParams } from '../ProfessocialCalendar'

const useDisplayCalendar = (changeDataParams: ((params: CalendarDateParams) => void) | undefined): [WeekObject[] | undefined, (e: number) => void] => {
  const [value, setValue] = useState<WeekObject[]>()

  const handleChange = (selectedDate: number) => {
    const workDate = new Date(selectedDate)

    const hour = workDate.getHours()
    const minute = workDate.getMinutes()
    const month = workDate.getMonth() + 1
    const year = workDate.getFullYear()

    const today = new Date(Date.now())
    const dayCount = daysInMonth(month, year)

    workDate.setDate(1)
    let firstWeekDay = workDate.getDay()
    // Sunday - Saturday : 0 - 6

    workDate.setDate(dayCount)
    let lastWeekDay = workDate.getDay()

    const actualMonth: CalendarDayObject[] = []
    let actualDay = false
    let published = false

    let i = 1
    while (i <= dayCount) {
      workDate.setDate(i)
      actualDay = datesAreOnSameDay(workDate, today)
      published = workDate <= today

      const weekday = workDate.getDay()
      actualMonth.push({
        month,
        day: i,
        year,
        date: new Date(year, month - 1, i, hour, minute),
        weekday,
        actualDay,
        actualMonth: true,
        published,
      })
      i += 1
    }

    let lastMonth: CalendarDayObject[] = []
    const nextMonth: CalendarDayObject[] = []

    let to = new Date()
    const from = new Date(workDate.getFullYear(), workDate.getMonth(), 1)

    // Auffüllen der vollen Wochen
    let newFirstWeek = 0
    // if firstWeekDay on Sunday
    if (firstWeekDay === 0) (firstWeekDay = 7)
    while (firstWeekDay > 1) {
      firstWeekDay -= 1
      let newMonth = month
      let newYear = workDate.getFullYear()
      if (month === 1) {
        newMonth = 12
        newYear -= 1
      } else {
        newMonth -= 1
      }
      const lastDayCount = daysInMonth(newMonth, newYear)
      lastMonth.push({
        month: newMonth,
        day: lastDayCount - newFirstWeek,
        date: new Date(newYear, newMonth, lastDayCount - newFirstWeek),
        year: newYear,
        weekday: firstWeekDay,
        actualDay: false,
        actualMonth: false,
        published: true,
      })
      from.setFullYear(newYear)
      from.setMonth(newMonth - 1)
      from.setDate((lastDayCount - newFirstWeek))
      newFirstWeek += 1
    }
    let newLastWeek = 0
    if (lastWeekDay === 7) {
      to = new Date(workDate.getFullYear(), workDate.getMonth(), workDate.getDate())
    }
    while (lastWeekDay < 7) {
      lastWeekDay += 1
      let newMonth = month
      let newYear = workDate.getFullYear()
      if (month === 12) {
        newMonth = 1
        newYear += 1
      } else {
        newMonth += 1
      }
      nextMonth.push({
        month: newMonth,
        day: 1 + newLastWeek,
        date: new Date(newYear, newMonth - 1, 1 + newLastWeek),
        year: newYear,
        weekday: lastWeekDay,
        actualDay: false,
        actualMonth: false,
        published: false,
      })
      to = new Date(newYear, newMonth - 1, 1 + newLastWeek)
      newLastWeek += 1
    }

    lastMonth = lastMonth.reverse()
    const completeCalendar: CalendarDayObject[] = []
    lastMonth.map((last: CalendarDayObject) => {
      completeCalendar.push(last)
    })
    actualMonth.map((actual: CalendarDayObject) => {
      completeCalendar.push(actual)
    })
    nextMonth.map((next: CalendarDayObject) => {
      completeCalendar.push(next)
    })

    const weeks: WeekObject[] = []

    let week: WeekObject = { days: [] }
    let counter = 0

    completeCalendar.map((elem: CalendarDayObject) => {
      if (counter !== 0 && counter % 7 === 0) {
        weeks.push(week)
        week = { days: [] }
      }
      counter += 1
      week.days.push(elem)
    })
    weeks.push(week)

    from.setHours(0)
    from.setMinutes(0)
    from.setSeconds(0)
    to.setHours(23)
    to.setMinutes(59)
    to.setSeconds(59)

    setValue(weeks)
    changeDataParams && changeDataParams({ from, to })
  }

  return [value, handleChange]
}
export default useDisplayCalendar
